import { Button, Stack, Typography, useTheme } from "@mui/material";
import { useSetAtom } from "jotai";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import {
	defaultPortfolioFilterState,
	portfolioFilterState,
} from "web_myplann/Shared/State/portfolioFilterAtom";

export const PortfolioFilterNoResults: FC = () => {
	const { t } = useResource();
	const theme = useTheme();
	const setFilter = useSetAtom(portfolioFilterState);

	return (
		<Stack
			alignItems="center"
			px={theme.spacingTokens.lg}
			py={theme.spacingTokens.xxl}
			spacing={theme.spacingTokens.md}
		>
			<Typography variant="body2" textAlign="center">
				{t(Resources.Portfolio.List.Redesign.filterNoResults)}
			</Typography>
			<Button
				variant="ghost"
				onClick={() => setFilter(defaultPortfolioFilterState)}
			>
				{t(Resources.Portfolio.List.Redesign.filterNoResultsAction)}
			</Button>
		</Stack>
	);
};
